import type { SVGProps } from "react";

export function SolarMagniferLinear(props: SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
			<title>Magnifier</title>
			<g fill="none" stroke="currentColor" strokeWidth="1.5">
				<path stroke="var(--svg-color, currentColor)" strokeWidth="1.5" d="m15.131 14.47 4 4" />
				<circle
					cx="11.1"
					cy="10.095"
					r="5.75"
					stroke="var(--svg-color, currentColor)"
					strokeWidth="1.5"
				/>
			</g>
		</svg>
	);
}

export function SolarMinimizeSquare3Linear(props: SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
			<g fill="none" stroke="currentColor" strokeWidth="1.5">
				<title>Minimize</title>
				<path
					strokeLinecap="round"
					d="M13 22c4.055-.008 6.178-.107 7.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.071 2 16.714 2 12 2S4.929 2 3.464 3.464C2.107 4.822 2.008 6.944 2 11"
				/>
				<path strokeLinecap="round" strokeLinejoin="round" d="m17 7l-5 5m0 0h3.75M12 12V8.25" />
				<path d="M2 18c0-1.886 0-2.828.586-3.414S4.114 14 6 14s2.828 0 3.414.586S10 16.114 10 18s0 2.828-.586 3.414S7.886 22 6 22s-2.828 0-3.414-.586S2 19.886 2 18Z" />
			</g>
		</svg>
	);
}
